import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { debounce } from 'lodash';
import { TrackingHandler } from 'client/tracking/handler';

import './slider-carousel.scss';

const SCROLL_DEBOUNCE_TIMEOUT = 500;

export function SliderCarousel({ className, scrollTrackingId, scrollTrackingParent, children }) {
  const onScroll = debounce(() => {
    TrackingHandler.fireEvent(scrollTrackingId, {
      event_data: { creative_id: scrollTrackingParent, action_cause: 'scroll' },
    });
  }, SCROLL_DEBOUNCE_TIMEOUT);

  return (
    <div
      className={classnames('css-slider-carousel d-flex pos-r', className)}
      onScroll={scrollTrackingId ? onScroll : null}
    >
      {children}
    </div>
  );
}

SliderCarousel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  scrollTrackingId: PropTypes.string,
  scrollTrackingParent: PropTypes.string,
};

SliderCarousel.defaultProps = {
  children: null,
  className: null,
  scrollTrackingId: null,
  scrollTrackingParent: null,
};
